import React, { useState, useRef, useEffect } from "react";
import "./PopupQuestion.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import question from '../imagesHome/question.png';

const PopupQuestion = () => {
  const [open, setOpen] = useState(false);
  const [closing, setClosing] = useState(false);
  const popupRef = useRef(null);

  const closePopup = () => {
    if (closing || (!open && !closing)) return;
    setOpen(false);
    setClosing(true);
    setTimeout(() => {
      setClosing(false);
    }, 300); // durata animației slideDown
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        closePopup();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open, closing]);

  useEffect(() => {
    if (open || closing) {
      document.body.classList.remove("quiz-active");
      document.documentElement.classList.remove("quiz-active");
    } else {
      document.body.classList.add("quiz-active");
      document.documentElement.classList.add("quiz-active");
    }

    return () => {
      document.body.classList.remove("quiz-active");
      document.documentElement.classList.remove("quiz-active");
    };
  }, [open, closing]);

  return (
    <div className="popup-question-container">
      <div
        className="oriented-question-track"
        onClick={() => {
          if (closing) return;
          setClosing(false);
          setOpen((prev) => !prev);
        }}
      >
        <img src={question} className="question-popup-icon" />
      </div>

      {(open || closing) && (
        <>
          <div className="popup-question-overlay" onClick={closePopup} />
          <div
            className={`popup-question ${open ? "open" : ""} ${closing ? "closing" : ""}`}
            ref={popupRef}
          >
            <button className="popup-question-close" onClick={closePopup}>
              ×
            </button>
            <div className="popup-question-content">
              <h3>Ai rămas blocat?</h3>
              <p>Folosește ajutoarele disponibile pentru a-ți continua lecția sau pentru a primi un indiciu.</p>
              <button className="popup-question-btn">Cere ajutor</button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PopupQuestion;
